import React, { FunctionComponent } from 'react';
import VariantCategoryTabs from '../../../../../../common/components/variantSelector/variantTabs/VariantCategoryTabs';

interface IVariantCategoryTabsContainerProps {
  setMarketingCategory: (e: React.SyntheticEvent, category: string) => void;
  selectedMarketingCategory?: string;
  marketingCategories: string[];
}

const VariantCategoryTabsContainer: FunctionComponent<IVariantCategoryTabsContainerProps> = ({
  setMarketingCategory,
  selectedMarketingCategory,
  marketingCategories,
}) => {
  return (
    <VariantCategoryTabs
      marketingCategories={marketingCategories}
      selectedMarketingCategory={selectedMarketingCategory}
      setMarketingCategory={setMarketingCategory}
    />
  );
};

export default VariantCategoryTabsContainer;
